import { useFeatureGate } from '@statsig/expo-bindings';
import { Redirect } from 'expo-router';
import React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    SafeAreaView,
    YStack,
} from 'smoothie';

import { FeatureFlags } from '../../feature-flags/FeatureFlags';
import { captureException } from '../../logger/Logger';

const ThrowError = () => {
    const { value: isInternalUser } = useFeatureGate(
        FeatureFlags.ENABLE_THROWERROR,
    );

    if (!isInternalUser) return <Redirect href="/" />;

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <YStack flex={1} alignItems="center" gap={24} padding={20}>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Capture Exception"
                    onPress={() => {
                        captureException(
                            new Error('Dummy Captured Fruitful Error'),
                        );
                    }}
                />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Throw Uncaught Error"
                    onPress={() => {
                        throw new Error('Dummy Thrown Fruitful Error');
                    }}
                />
            </YStack>
        </SafeAreaView>
    );
};

export default ThrowError;
